import { render, staticRenderFns } from "./ModelFileInput.vue?vue&type=template&id=47d3b220&scoped=true&"
import script from "./ModelFileInput.vue?vue&type=script&lang=js&"
export * from "./ModelFileInput.vue?vue&type=script&lang=js&"
import style0 from "./ModelFileInput.vue?vue&type=style&index=0&id=47d3b220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d3b220",
  null
  
)

export default component.exports